import React from 'react';
import T from 'prop-types';
import { Link, IndexLink } from 'react-router';
import classnames from 'classnames/bind';
import 'whatwg-fetch'
import VisibilitySensor from 'react-visibility-sensor';

// Using CSS Modules so we assign the styles to a variable
import s from './App.styl';
const cx = classnames.bind(s);
import logo from './react-logo.png';
import background from '../images/background.jpg';
import shareIcon from '../images/share.png';
import lock from '../images/lock.png';
import pw from './pw';
import videoData from './videoData.json'

// Favicon link is in the template, this just makes webpack package it up for us
import './favicon.ico';

import { isMobile, hashPass, store } from './utils'
const storage = store()

export class VimeoVideo extends React.Component {
  constructor (props) {
    super(props)
    this.state = {}
  }

  componentDidMount () {
    if (this.props.autoplay) {
      this.play()
      this.myRef.scrollIntoView({behavior: 'smooth', block: 'center', inline: 'center'})
    }
  }

  load () {
    this.thePlayer = new Vimeo.Player(`vimeo-${this.props.id}`, {
      width: isMobile ? 160 : 275,
      autoplay: !isMobile,
      playsinline: false,
      responsive: true
    });
    this.thePlayer.ready().then(() => {
      this.setState({ loaded: true, loading: false })
    })
  }

  markAsPlayed () {
    let playedVideos = JSON.parse(storage.getItem('playedVideos') || '{}')
    playedVideos[this.props.id] = new Date().getTime()
    storage.setItem('playedVideos', JSON.stringify(playedVideos))
  }

  play () {
    this.load()
    this.markAsPlayed()
    this.setState({ loading: true })
    this.thePlayer.on('play', () => {
      this.thePlayer.requestFullscreen()
    })
    this.thePlayer.on('fullscreenchange', ({ fullscreen }) => {
      if (!fullscreen) this.thePlayer.pause()
    })
  }

  visibilityChange (isVisible) {
    if (isMobile && isVisible && !this.thePlayer) {
      this.load()
    }
  }

  hasPlayedVideo (id, { ids }) {
    return ids.includes(id)
  }

  formatPlayedDate(id, { timestamps }) {
    const o_date_en = new Intl.DateTimeFormat('en');
    const f_date = (m_ca, m_it) => Object({...m_ca, [m_it.type]: m_it.value});
    const { month, day, year } = o_date_en.formatToParts(timestamps[id]).reduce(f_date, {})
    return `${month}/${day}/${year}`
  }

  render () {
    return (
      <VisibilitySensor onChange={this.visibilityChange.bind(this)}>
        <div className={cx('video', { selected: this.props.autoplay })} ref={ (ref) => this.myRef=ref }>
          <div className={cx('video-inside')}>
          { !this.state.loaded && (
              <div className={cx('video-thumbnail')} style={{'backgroundImage': `url(${this.props.thumbnail})`}} onClick={this.play.bind(this)}>
                <div className={cx('video-play-button')}>
                  { !this.state.loading ? (
                      <svg viewBox="0 0 20 20" preserveAspectRatio="xMidYMid" className={cx('video-play-icon')}>
                        <title id="play-icon-title">Play</title>
                        <polygon points="1,0 20,10 1,20"></polygon>
                      </svg>
                    ) : (
                      <svg viewBox="0 0 20 20" preserveAspectRatio="xMidYMid" className={cx('video-play-icon')}>
                        <title id="pause-icon-title">Pause</title>
                        <rect width="6" height="20" x="0" y="0"></rect>
                        <rect width="6" height="20" x="12" y="0"></rect>
                      </svg>
                    )
                  }
                </div>
              </div>
          )}
          <div className={cx('video-placeholder')} data-vimeo-id={this.props.id} id={`vimeo-${this.props.id}`}></div>
          <a href={`/video/${this.props.id}`} target="_blank">
          <img className={cx('share-button')} src={shareIcon} />
          </a>
          <h4>{this.props.name}</h4>
          { this.hasPlayedVideo(this.props.id, this.props.playedVideos) ? (
            <div className={cx('recently-played')}>Watched</div>
          ) : ''}
          <h5>{this.props.date}</h5>
          </div>
        </div>
      </VisibilitySensor>
    )
  }
}

const sectionColors = ['#dee6e6', '#ebf0f0']
class VideoSection extends React.Component {

  render () {
    let videos = [...this.props.videos]
    videos.sort((a, b) => {
      const [a1, a2, a3] = a.date.split('/')
      const [b1, b2, b3] = b.date.split('/')

      let aDate = `${a1}/${a2}/${a3}`
      let bDate = `${b1}/${b2}/${b3}`

      if (!a2) aDate = `12/31/${a1}` 
      if (!b2) bDate = `12/31/${b1}`

      if (a2 && !a3) aDate = `${a1}/1/${a2}`
      if (b2 && !b3) bDate = `${b1}/1/${b2}`

      return new Date(aDate).getTime() - new Date(bDate).getTime()
    })

    return (
      <div className={cx('video-section')}>
        <div className={cx('video-section-year')}>
          <h3>{this.props.year}</h3>
        </div>
        <div className={cx('videos')}>
          { videos.map(video => { return (
            <VimeoVideo
              {...video}
              playedVideos={this.props.playedVideos}
              key={`vid-${video.id}`}
              autoplay={this.props.linkedVideo == video.id}
            />
          )})}
        </div>
      </div>
    )
  }
}

class VideoSections extends React.Component {
  render () {
    const dates = Object.keys(this.props.videos)
    const dateRange = [Math.min(...dates),Math.max(...dates)]
    let toRender = []
    let usedYear = 0

    const playedVideos = JSON.parse(storage.getItem('playedVideos') || '{}')
    try {
    for (let i = dateRange[0]; i <= dateRange[1]; i++) {
      if (this.props.videos[i]) {
        usedYear++
        toRender.push(
          <VideoSection
            year={i}
            videos={this.props.videos[i]}
            key={`section-${i}`}
            bg={sectionColors[usedYear % 2]}
            playedVideos={{ ids: Object.keys(playedVideos), timestamps: playedVideos }}
            linkedVideo={this.props.linkedVideo}
          />
        )
      }
    }
    } catch (e) {
      console.log(e)
    }
    return (
      <div>
      {toRender}
      </div>
    )
  }
}

class Stats extends React.Component {
  render () {
    return (
      <div className={cx('stat-box')}>
        <div className={cx('stat')}>
          <div className={cx('stat-number')}>{this.props.videoCount}</div>
          <div className={cx('stat-text')}>videos</div>
        </div>
        <div className={cx('stat')}>
          <div className={cx('stat-number')}>{Object.keys(this.props.videos).length}</div>
          <div className={cx('stat-text')}>years</div>
        </div>
      </div>
    )
  }
}

class Header extends React.Component {
  onClick () {
    this.ref.scrollIntoView({behavior: 'smooth'})
  }
  render() {
    return (
      <div className={cx('header-outside')}>
        <div className={cx('header')} style={{background: `url(${background}) no-repeat center 70%`}}>
          <div className={cx('header-border')}>
            <div className={cx('header-text')}>
              <h1>Stein Family</h1>
              <div className={cx('h2-background')}>
                <h2>Home Videos</h2>
              </div>
            </div>
            { this.props.noButton !== true && (
              <div className={cx('header-below')} onClick={this.onClick.bind(this)}>
                <div className={cx('header-arrow')} />
              </div>
            )}
          </div>
        </div>
        <div ref={(ref) => this.ref = ref}></div>
      </div>
    );
  }
}

export class Home extends React.Component {
  constructor (props) {
    super(props)
    this.state = {}
  }

  onChange () {
    this.setState({
      thing: Math.random()
    })
  }

  render() {
    const userPass = storage.getItem('password')

    // FOR BUiLD
    if (userPass == '__IS_BUILD__') {
      return (
        <div className={cx('page')}>
          <Header />
        </div>
      )
    }

    if (!userPass || hashPass(userPass) !== +pw) {
      return (
        <div className={cx('page')}>
          <Auth onChange={this.onChange.bind(this)} />
        </div>
      )
    }

    if (!this.props.videoCount) {
      return (
        <div className={cx('page')}>
          <Header />
          <div className={cx('loading')}>
            <div className={cx('loader')} />
            Loading videos 
          </div>
        </div>
      )
    }

    return (
      <div className={cx('page')}>
        <Header />
        <Stats {...this.props} />
        <VideoSections videos={this.props.videos} linkedVideo={this.props.linkedVideo} />
        <Footer />
      </div>
    );
  }
}

class Footer extends React.Component {
  render() {
    return (
      <div className={cx('footer')}>
        Made with <span>&hearts;</span> by Tyke
      </div>
    );
  }
}

export class NotFound extends React.Component {
  render() {
    return (
      <div className={cx('page')}>
        <h4>Not found</h4>
      </div>
    );
  }
}

export class Auth extends React.Component {
  constructor (props) {
    super(props)
    this.state = {}
  }

  onChange (e) {
    this.setState({
      password: e.target.value
    })
  }

  handleKeyPress (evt) {
    if (evt.key == 'Enter') {
      this.attemptPassword()
    }
  }

  attemptPassword () {
    const hashedPass = hashPass(this.state.password)

    if (hashedPass === +pw) {
      storage.setItem('password', this.state.password)
      this.props.onChange()
    }
  }

  render() {
    return (
      <div className={cx('auth')} style={{background: `url(${background}) no-repeat center 70%`}}>
        <div className={cx('auth-outside')}>
          <div className={cx('auth-inside')}>
            <div className={cx('auth-header')}>
              <div className={cx('auth-text')}>Please enter password to continue.</div>
            </div>
            <input className={cx('auth-input')} onChange={this.onChange.bind(this)} type='password' onKeyPress={this.handleKeyPress.bind(this)} />
            <div className={cx('button')} onClick={this.attemptPassword.bind(this)}>Continue</div>
          </div>
        </div>
        <Header noButton />
      </div>
    )
  }
}

export class App extends React.Component {
  static propTypes = {
    children: T.node,
  };

  constructor (props) {
    super(props)
    this.state = {
      videos: [],
      videoCount: 0,
      linkedVideo: props.params ? props.params.videoId : 0
    }
  }

  getThumbnail ({ pictures }) {
    const { sizes } = pictures
    let res
    for (let i = 0; i < sizes.length; i++) {
      if (sizes[i].width > 350) {
        res = sizes[i].link
        break
      }
    }
    return res
  }

  componentDidMount () {
    setTimeout(() => {
      let vh = window.innerHeight * 0.01
      document.documentElement.style.setProperty('--vh', `${vh}px`)
    }, 500)
  }

  fetchVideoData () {
    window.fetch('https://api.vimeo.com/users/53248139/projects/3061216/videos?per_page=100', {
      method: 'GET',
      headers: {
        'Authorization': 'bearer e33da6729f9b3e2342a474ede5a4afc1'
      }
    })
    .then((response) => response.json())
    .then((responseData) => {
      console.log(responseData)
      try {
        let videosByDate = {}
        let videoCount = responseData.data.length
        responseData.data.map(vid => {
          const [videoDate, videoName] = vid.name.split(' | ')
          const [,,id] = vid.uri.split('/')
          const thumbnail = this.getThumbnail(vid)

          const year = (date => {
            if (date.indexOf('/') > -1) {
              const [,yrr,yr] = date.split('/')
              if (yr) return yr
              return yrr
            } else {
              return date
            }
          })(videoDate)

          videosByDate[year] = videosByDate[year] || []
          videosByDate[year].push({
            date: videoDate,
            name: videoName,
            id,
            thumbnail
          })
        })

        this.setState({
          videos: videosByDate,
          videoCount
        })

      } catch (e) {
        console.log(e)
      }
    }).catch(e => {
      console.log(e)
    })
  }

  componentWillMount () {
    if (videoData) {
      this.setState({
        videos: videoData.videos,
        videoCount: videoData.count
      })
    } else {
      this.fetchVideoData()
    }
  }

  render() {
    return (
      <div className={cx('App')}>
        {React.cloneElement(this.props.children, { ...this.state })}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./client/components/App.js